import { useTranslation } from "react-i18next";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { LogOut, User } from "lucide-react";

export function Header() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const currentMembership = user?.currentMembership ?? null;

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="flex min-h-14 items-center justify-end border-b bg-background/95 px-4 backdrop-blur">
      <div className="flex shrink-0 items-center gap-2">
        <div className="hidden text-right sm:block">
          <div className="text-sm font-medium leading-tight">
            {currentMembership?.displayName ?? user?.fullName ?? ""}
          </div>
          <div className="mt-0.5 max-w-56 truncate text-xs text-muted-foreground">
            {user?.email ?? ""}
          </div>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" aria-label={t("header.accountMenu")}>
              <User className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-64">
            <DropdownMenuLabel>
              <span className="block truncate">
                {currentMembership?.displayName ?? user?.fullName ?? ""}
              </span>
              <span className="mt-1 block truncate text-xs font-normal text-muted-foreground">
                {user?.email}
              </span>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => navigate("/console/account/security")}>{t("sidebar.accountSecurity")}</DropdownMenuItem>
            <DropdownMenuItem onClick={handleLogout}>
              <LogOut className="mr-2 h-4 w-4" />
              {t("header.logout")}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
